import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-comodato-cadastro',
  templateUrl: './comodato-cadastro.component.html',
})
export class ComodatoCadastroComponent {

  @Input() formulario!: FormGroup;

  @Output() buscarCliente = new EventEmitter<void>();
  @Output() buscarProduto = new EventEmitter<void>();
}
